// LivestreamDetailModals.jsx
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';
import UniversalComponent from '../component/UniversalComponent.jsx';

import { ModalId } from '../resource/trackingConstants.js';
import { liveStreamSessionLeaderboardCategory } from '../resource/liveStreamConstants.js';
import { NULL_FUNCTION } from '../resource/defaults.js';

export const LivestreamDetailModals = ({
  streamId = null,
  deviceHeight = 0,
  addvalue = NULL_FUNCTION,
  handleCleanModeChange = NULL_FUNCTION,
  openLivestreamPopOutChat = NULL_FUNCTION,
  reloadPlayer = NULL_FUNCTION,
  closeModal = NULL_FUNCTION,
  openModal = NULL_FUNCTION,
}) => {
  const closePowerSavingModeWarningModal = useCallback(() => {
    closeModal({ ids: ['LiveStreamPowerSavingModeWarningModal'] });
  }, [closeModal]);
  const closeLiveStreamSettingMenu = useCallback(() => {
    closeModal({ ids: ['LiveStreamSettingMenu'] });
  }, [closeModal]);
  const openLiveStreamInformation = useCallback(() => {
    openModal({ id: 'LiveStreamInformationModal' });
    closeLiveStreamSettingMenu();
  }, [openModal, closeLiveStreamSettingMenu]);
  const closeLiveStreamLimitedChatModal = useCallback(() => {
    closeModal({ ids: ['LiveStreamLimitedChatModal'] });
  }, [closeModal]);
  return (
    <>
      <ModalView id={'LiveStreamGiftLeaderboard'}>
        <UniversalComponent
          filename="Container_LiveStreamGiftLeaderboard"
          streamId={streamId}
          userId={streamId}
          category={liveStreamSessionLeaderboardCategory.TOTAL}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/LiveStreamGiftLeaderboard.js')
          }
        />
      </ModalView>
      <ModalView
        id="LiveStreamSettingMenu"
        render={() => (
          <UniversalComponent
            filename="Container_LiveStreamSettingMenu"
            modalId="LiveStreamSettingMenu"
            streamId={streamId}
            reloadPlayer={reloadPlayer}
            openLiveStreamInformation={openLiveStreamInformation}
            closeModal={closeLiveStreamSettingMenu}
            handleCleanModeChange={handleCleanModeChange}
            openLivestreamPopOutChat={openLivestreamPopOutChat}
            importer={
              /* #__LOADABLE__ */ () =>
                import('../container/LiveStreamSettingMenu.js')
            }
          />
        )}
      />
      <ModalView
        modalId={ModalId.LiveStream.LivestreamFreeLimitChat}
        id="LiveStreamLimitedChatModal"
      >
        <UniversalComponent
          filename="Container_LiveStreamLimitedChat"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/LiveStreamLimitedChat.js')
          }
          streamId={streamId}
          deviceHeight={deviceHeight}
          addvalue={addvalue}
          closeModal={closeLiveStreamLimitedChatModal}
        />
      </ModalView>
      <ModalView id="LiveStreamPowerSavingModeWarningModal">
        <UniversalComponent
          filename="Component_LiveStreamPowerSavingModeWarning"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../component/LiveStreamPowerSavingModeWarning.jsx')
          }
          deviceHeight={deviceHeight}
          reloadPlayer={reloadPlayer}
          closeModal={closePowerSavingModeWarningModal}
        />
      </ModalView>
      <ModalView
        id="PrivateShowNoticeModal"
        modalId={ModalId.LiveStream.LivestreamShowNotice}
        render={() => (
          <UniversalComponent
            filename="Container_PrivateShowNoticeModal"
            mixpanelModalId={ModalId.LiveStream.LivestreamShowNotice}
            importer={
              /* #__LOADABLE__ */ () =>
                import('../container/PrivateShowNoticeModal.js')
            }
          />
        )}
      />
      <ModalView
        id="LivestreamAlertModal"
        modalId={ModalId.LiveStream.ModalLivestreamAlert}
        render={() => (
          <UniversalComponent
            filename="Container_LivestreamAlertModal"
            mixpanelModalId={ModalId.LiveStream.ModalLivestreamAlert}
            importer={
              /* #__LOADABLE__ */ () =>
                import('../container/LivestreamAlertModal.js')
            }
          />
        )}
      />
      <ModalView id="LiveStreamInformationModal">
        <UniversalComponent
          filename="Container_LiveStreamInformationModal"
          streamId={streamId}
          userId={streamId}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/LiveStreamInformationModal.js')
          }
        />
      </ModalView>
      <UniversalComponent
        filename="Container_TimeNotSyncWithServerModal"
        streamId={streamId}
        importer={
          /* #__LOADABLE__ */ () =>
            import('../container/TimeNotSyncWithServerModal.js')
        }
      />
      <ModalView
        id="LivestreamSuperChatDialogModal"
        modalId={ModalId.LiveStream.SuperchatSendConfirm}
      >
        <UniversalComponent
          filename="Container_LivestreamSuperChatDialogModal"
          streamId={streamId}
          trackingModalId={ModalId.LiveStream.SuperchatSendConfirm}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/LivestreamSuperChatDialogModal.js')
          }
        />
      </ModalView>
      <ModalView id="GiftAnimationFailedConfirmModal">
        <UniversalComponent
          filename="Container_GiftAnimationFailedConfirmModal"
          streamId={streamId}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/GiftAnimationFailedConfirmModal.js')
          }
        />
      </ModalView>
    </>
  );
};

LivestreamDetailModals.propTypes = {
  streamId: PropTypes.string,
  deviceHeight: PropTypes.number,
  addvalue: PropTypes.func,
  handleCleanModeChange: PropTypes.func,
  openLivestreamPopOutChat: PropTypes.func,
  reloadPlayer: PropTypes.func,
  closeModal: PropTypes.func,
  openModal: PropTypes.func,
};

export default LivestreamDetailModals;
